import { Market } from 'types';
import { CapitolaClient } from './base';

export default class MarketClient extends CapitolaClient<Market> {
  public get resourceName(): string {
    return 'market';
  }
}
